import { UserFilterResponse, UserToReassign } from "../../../../../../../service/user/response";
import { ReassignRow } from "../components/reassign/types";
import { TrackingRow } from "../components/tracking/types";

export const formatUsersToReassign = ({ users }: { users: UserToReassign[] }): ReassignRow[] => {
    if (!users?.length) { return [] }

    return users.map(user => ({
        curp: user.curp ?? '',
        division: "",
        id: String(user.id ?? ''),
        name: `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim(),
        role: user.role ?? "",
        userType: user.userType ?? ""
    }))
}
export const formatUsersToTracking = ({ users = [], oldUsersList = [], usersSelecteds }: { users: UserFilterResponse[]; usersSelecteds: string[]; oldUsersList: TrackingRow[] }): TrackingRow[] => {
    if (!users?.length && !oldUsersList?.length) { return [] }
    const oldUsers = oldUsersList.filter(oldUser => usersSelecteds.includes(oldUser.id) && !users.some(user => String(user.id) == oldUser.id))
    const userList = users.map(user => ({
        curp: user.curp ?? '',
        division: user.division ?? "",
        id: String(user.id ?? ''),
        name: user.fullName ?? "",
        role: user.role ?? "",
        userType: user.userType ?? ""
    }))
    return [...oldUsers, ...userList]
}